<template>
  <div :class="type" class="confetti-message">
    <div class="confetti-message-content">
      <div v-if="!parsedHideIcon" class="confetti-message-icon">
        <ConfettiIcon :icon="icon" />
      </div>
      <div class="h5 confetti-message-text">
        <slot />
      </div>
      <div
        v-if="parsedCanClose"
        class="confetti-message-close-icon"
        @click="$emit('close')"
        @keyup.enter="$emit('close')"
      >
        <ConfettiIcon icon="times" />
      </div>
    </div>
  </div>
</template>

<script>
import ConfettiIcon from "./ConfettiIcon";
import { strToBool } from "../utils";

export const ICON_MAP = {
  error: "exclamation-square-o",
  info: "info-square",
  success: "check-o",
  warning: "exclamation-triangle-o",
};

export const typeValidator = (value) => Object.keys(ICON_MAP).includes(value);

export default {
  name: "ConfettiMessage",
  components: { ConfettiIcon },
  props: {
    canClose: {
      default: true,
      type: [Boolean, String],
    },
    hideIcon: {
      default: false,
      type: [Boolean, String],
    },
    type: {
      default: "info",
      required: true,
      type: String,
      validator: typeValidator,
    },
  },
  computed: {
    icon() {
      return ICON_MAP[this.type];
    },
    parsedCanClose() {
      return strToBool(this.canClose);
    },
    parsedHideIcon() {
      return strToBool(this.hideIcon);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "confetti/scss/variables/breakpoints";
@import "confetti/scss/variables/colors";
@import "confetti/scss/variables/layout";
@import "confetti/scss/utils/mixins";
@import "confetti/scss/components/confetti-message";
</style>
